export const prefix = "/api_documentation/";
export default prefix;
